export function delay(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

/** Parses a `Retry-After` header (seconds, or an HTTP date) into milliseconds. */
export function parseRetryAfterMs(
  retryAfterHeader: string | undefined
): number | null {
  if (!retryAfterHeader) {
    return null;
  }

  const asSeconds = Number.parseInt(retryAfterHeader, 10);
  if (!Number.isNaN(asSeconds)) {
    return asSeconds * 1000;
  }

  const asDate = Date.parse(retryAfterHeader);
  if (!Number.isNaN(asDate)) {
    return Math.max(0, asDate - Date.now());
  }

  return null;
}

/** Exponential backoff with jitter, capped so a mistuned retry count can't stall the UI for minutes. */
export function getRetryDelayMs(
  attempt: number,
  baseDelayMs: number,
  retryAfterHeader?: string
): number {
  const fromHeader = parseRetryAfterMs(retryAfterHeader);
  if (fromHeader !== null) {
    return fromHeader;
  }

  const MAX_DELAY_MS = 10_000;
  const exponential = baseDelayMs * 2 ** (attempt - 1);
  const jitter = Math.random() * baseDelayMs; // NOSONAR

  return Math.min(exponential + jitter, MAX_DELAY_MS);
}
